export default __webpack_public_path__ + "static/summary-a27afd64dcb0ac97d0dbb94474fefcc6.png";